import { roundIdParamSchema, teamIdParamSchema } from '~/schemas';
import { ButtonLink } from '~/components/ButtonLink/ButtonLink';
import { useRemoveRoundResultMutation } from '../mutations';
import { useRoundResultsListQuery } from '../../queries';
import { Table } from '~/components/Table/Table';
import { useParams } from '~/hooks/useParams';
import { formatPoints } from '~/utils/points';
import { CompetitionResult } from '~/apis/ssf';
import { toast } from 'react-toastify';
import { Fragment } from 'react/jsx-runtime';
import { Heading } from '~/components/Heading/Heading';

function Row({ result, roundResultsId }: { result: CompetitionResult; roundResultsId: number }) {
  const removeMutation = useRemoveRoundResultMutation();

  async function handleRemove(id: number, resultId: number) {
    await toast.promise(removeMutation.mutateAsync({ id, payload: { results: [resultId] } }), {
      success: 'Resultatet har tagits bort',
      pending: 'Tar bort resultat...',
      error: 'Kunde inte ta bort resultat',
    });
  }

  return (
    <Table.Row key={result.id}>
      <Table.Col>{result.person.license_id}</Table.Col>
      <Table.Col>{`${result.person.first_name} ${result.person.last_name}`}</Table.Col>
      <Table.Col>{formatPoints(result.points)}</Table.Col>
      <Table.Col>
        <ButtonLink onClick={() => handleRemove(roundResultsId, result.id)}>Ta bort</ButtonLink>
      </Table.Col>
    </Table.Row>
  );
}

interface Props {
  resultsPerRound: number;
}

export function CurrentResultsListTable({ resultsPerRound }: Props) {
  const { teamId } = useParams(teamIdParamSchema.parse);
  const { roundId } = useParams(roundIdParamSchema.parse);
  const { data, isLoading } = useRoundResultsListQuery({ team: teamId, round: roundId });

  if (!data) return false;

  const results = data.results[0].results;

  return (
    <Fragment>
      <Heading as="h4">
        Resultat ({results.length}/{resultsPerRound})
      </Heading>
      <Table bg="even">
        <Table.Head>
          <Table.Row>
            <Table.Col as="th">License</Table.Col>
            <Table.Col as="th">Namn</Table.Col>
            <Table.Col as="th" tooltip="Poängsystem: IPFGL">
              Poäng
            </Table.Col>
            <Table.Col as="th" />
          </Table.Row>
        </Table.Head>
        <Table.Body>
          {isLoading ? (
            <Table.Loading cols={4} />
          ) : (
            results.map(result => <Row result={result} roundResultsId={data.results[0].id} key={result.id} />)
          )}
        </Table.Body>
      </Table>
    </Fragment>
  );
}
